jQuery(document).ready(function ($) {
    $('input').each(function () {
        var $input = $(this);
        if (!$input.attr('aria-label') && $input.attr('placeholder')) {
            $input.attr('aria-label', $input.attr('placeholder'));
        }
    });
    $('select').each(function () {
        var $select = $(this);
        if (!$select.attr('aria-label') && $select.attr('title')) {
            $select.attr('aria-label', $select.attr('title'));
        }
    });
    $('input[type="submit"]').each(function () {
        var $submit = $(this);
        if (!$submit.attr('aria-label') && $submit.attr('value')) {
            $submit.attr('aria-label', $submit.attr('value'));
        }
    });

    $('.parent-accessibility').each(function () {
        var $menuItem = $(this);
        var $link = $menuItem.find('> a');
        var $submenu = $menuItem.find('> ul');

        // Set initial accessibility attributes
        $link.attr('aria-haspopup', 'true');
        $link.attr('aria-expanded', 'false');
        $link.attr('aria-controls', $submenu.attr('id') || 'submenu-' + $menuItem.index());

        // Hover functionality (for mouse users)
        $menuItem.hover(
            function () {
                $link.attr('aria-expanded', 'true');
                $submenu.stop(true, true).slideDown(200);
            },
            function () {
                $link.attr('aria-expanded', 'false');
                $submenu.stop(true, true).slideUp(200);
            }
        );

        // Keyboard support for opening the submenu with Enter/Space
        $link.on('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();

                // Toggle the submenu visibility
                if ($submenu.is(':visible')) {
                    $link.attr('aria-expanded', 'false');
                    $submenu.stop(true, true).slideUp(200);
                } else {
                    $link.attr('aria-expanded', 'true');
                    $submenu.stop(true, true).slideDown(200);

                    // Focus on the first submenu item
                    $submenu.find('a').first().focus();
                }
            }
        });

        // Keyboard navigation for submenu items (use arrows)
        $submenu.find('a').on('keydown', function (event) {
            if (event.key === 'ArrowDown') {
                var $nextItem = $(this).parent().next().find('a');
                if ($nextItem.length > 0) {
                    $nextItem.focus();
                }
            } else if (event.key === 'ArrowUp') {
                var $prevItem = $(this).parent().prev().find('a');
                if ($prevItem.length > 0) {
                    $prevItem.focus();
                }
            } else if (event.key === 'Escape') {
                $link.attr('aria-expanded', 'false');
                $submenu.stop(true, true).slideUp(200);
            }
        });

        $link.on('focus', function () {
            if ($submenu.is(':hidden')) {
                $link.attr('aria-expanded', 'true');
                $submenu.stop(true, true).slideDown(200);
            }
        });

        // Handle losing focus on the submenu and parent item
        $link.on('blur', function (event) {
            setTimeout(function () {
                // Check if the active element is outside the entire menu or submenu
                if (!$(document.activeElement).closest($menuItem).length) {
                    $link.attr('aria-expanded', 'false');
                    $submenu.stop(true, true).slideUp(200);
                }
            }, 200);
        });

        // Close the submenu when clicking outside
        $(document).on('click', function (event) {
            if (!$(event.target).closest($menuItem).length) {
                $link.attr('aria-expanded', 'false');
                $submenu.stop(true, true).slideUp(200);
            }
        });

        // Detect if focus has moved outside of the submenu, and close it
        $submenu.on('focusout', function (event) {
            var nextFocusedElement = $(event.relatedTarget);
            if (!nextFocusedElement.closest($submenu).length) {
                $link.attr('aria-expanded', 'false');
                $submenu.stop(true, true).slideUp(200);
            }
        });
    });



});
